import { lighten, darken } from "@mui/material/styles";
import { APP_COMPANY_COLOR } from "consts";

declare module "@mui/material/styles" {
  interface TypeBackground {
    alternative: string;
  }
}

export type ColorName = "primary" | "secondary" | "error" | "warning" | "info" | "success";

export const palette = {
  primary: {
    main: APP_COMPANY_COLOR,
    light: lighten(APP_COMPANY_COLOR, 0.1),
    dark: darken(APP_COMPANY_COLOR, 0.1),
  },
  secondary: {
    main: "#444",
    light: "#ccc",
    dark: "#111",
  },
  error: {
    main: "#d32f2f",
    light: "#f4cbcb",
    dark: "#9e2323",
  },
  warning: {
    main: "#ef6c00",
    light: "#fbdabf",
    dark: "#b35100",
  },
  info: {
    main: "#3996DC",
    light: "#cde4f6",
    dark: "#2a70a5",
  },
  success: {
    main: "#2e7d32",
    light: "#cadecb",
    dark: "#225d25",
  },
  common: {
    black: "#000",
    white: "#fff",
  },
  grey: {
    50: "#fafafa",
    100: "#eee",
    200: "#ddd",
    300: "#bbb",
    400: "#aaa",
    500: "#999",
    600: "#888",
    700: "#666",
    800: "#333",
    900: "#222",
    A100: "#f8f8f8",
    A200: "#e8e8e8",
    A400: "#d8d8d8",
    A700: "#787878",
  },
  text: {
    primary: "#333",
    secondary: "#999",
    disabled: "#ccc",
  },
  background: {
    default: "#f3f2f5",
    paper: "#fff",
    alternative: "#ece8f4",
  },
  divider: "#dadada",
} as const;

export default palette;
